const jQuery = require('jquery');

const scrollWindow = function() {
    if (window.innerWidth > 900) {
        // scroll up so that content is not hidden by sticky header
        window.scrollBy(0, -250);
    }
    const id = window.location.hash.substr(1);
    const root = document.getElementById(id);
    const child = root.firstElementChild;
    if (child && child.classList.contains('collapsible')) {
        root.firstElementChild.classList.add('active');
    } else if (jQuery(root).siblings('.collapsible')) {
        jQuery(root).siblings('.collapsible').addClass('active');
    }
};
window.onload = () => {
    if (window.location.hash) {
        scrollWindow();
    }
};
window.onhashchange = scrollWindow;
